import { createSvgIcon } from "@mui/material";

export const PlacementBottomIcon = createSvgIcon(
  <svg viewBox="0 0 12 9" fill="none">
    <path
      fill="currentColor"
      d="M9.281.844a.85.85 0 0 1-.844.844H3.375a.833.833 0 0 1-.844-.844A.85.85 0 0 1 3.375 0h5.063c.448 0 .843.396.843.844M0 7.599a.85.85 0 0 1 .844-.844h10.125c.448 0 .844.396.844.844a.85.85 0 0 1-.844.844H.844A.833.833 0 0 1 0 7.599m9.281-3.375a.85.85 0 0 1-.844.843H3.375a.833.833 0 0 1-.844-.843.85.85 0 0 1 .844-.844h5.063c.448 0 .843.396.843.844"
    />
  </svg>,
  "PlacementBottomIcon",
);
